import classnames from 'classnames';

const variants = {
  primary: 'bg-[#64247f] text-white border border-[#64247f]',
  outline: 'bg-white border border-[#64247f] text-[#64247f]',
  secondary: 'bg-gray-100 border border-gray-100 text-gray-600',
};

const sizes = {
  sm: '', //при необходимости настроить
  md: 'rounded-[20px] h-8 text-base',
  lg: 'rounded-[50px] h-14 text-lg',
};
interface ButtonProps extends React.HtmlHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
}

export const Button = ({
  className,
  children,
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) => {
  return (
    <button
      className={classnames(
        sizes[size],
        variants[variant],
        'px-3 font-medium hover:opacity-70 transition inline-flex items-center justify-center whitespace-nowrap flex-shrink-0',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
